// extracted by mini-css-extract-plugin
module.exports = {"delete":"PartyForm_delete_30Wt9"};